// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../node_modules/bootstrap/dist/css/bootstrap.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/images/menu-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23db0b27%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/images/user-menu-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::selection {
  color: #fff;
  background: #db0b27;
}

body {
  color: #2b363b;
  font-family: "Red Hat Display", "Poppins", sans-serif;
}

.Toastify__progress-bar-theme--light {
  background: #db0b27 !important;
}

.Toastify__toast-container {
  width: 350px !important;
}

.passwordIcon {
  width: 24px;
  height: 24px;
}

.red-text {
  color: #db0b27;
}

.text-right {
  text-align: right;
}

.menu-logo-mobile {
  width: 160px;
}

.menu-user-icon {
  width: 32px;
  margin-left: 8px;
}

.menu-facturas-icon {
  width: 41px;
}

.menu-repostajes-icon {
  width: 53px;
}

.menu-promotion-icon {
  width: 39px;
  margin-left: 1px;
}

.menu-stats-icon {
  width: 44px;
}

.menu-flotas-icon {
  width: 45px;
}

/* General Styles */
.page-header {
  background-color: #fff;
  border-radius: 0 0 20px 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  margin-left: -6vw !important;
  padding-top: 6em;
  padding-bottom: 1em;
  position: fixed;
  width: 100vw;
  z-index: 19;
}

.username {
  display: block;
  text-align: left;
  font-weight: 800;
}

.user-email {
  display: block;
  text-align: left;
  font-size: 0.9em;
  color: #aaa;
  text-transform: lowercase;
}

.has-flotas {
  padding-top: 10em;
}

.no-shadow {
  box-shadow: none !important;
}

/* .flotas.has-flotas {
  padding-top: 26vh;
} */

.page-header h1 {
  font-size: 1.5em;
  font-weight: 700;
}

h2 {
  font-weight: 700;
  font-size: 1.3em;
}

.content-page {
  padding-top: 6vh;
}

.content-section {
  margin-top: 24vh;
}

.content-has-flotas {
  margin-top: 18em;
}

.flotas.content-has-flotas {
  margin-top: 23em;
}

.section {
  box-shadow: 0px 20px 50px rgba(191, 21, 108, 0.05);
  border-radius: 20px;
}

.section-header-text {
  height: 1.5em;
  line-height: 1.5em;
}

.section-header-btn {
  display: flex;
  justify-content: flex-end;
}

.icon-bg {
  padding: 1.09em 1.09em;
  background-color: #ececec;
  border-radius: 0.5em;
}

a.no-decoration {
  color: inherit;
  cursor: pointer;
  text-decoration: none;
}

/* Nav Styles */
.navbar {
  background-color: #fff;
  display: block;
  padding-top: 4.1em;
  position: fixed;
  width: 100vw;
  z-index: 20;
}

.me-auto a {
  border: none;
  border-bottom: 1px solid #c4c4c4;
}

.menu span,
.offcanvas span {
  color: #2b363b;
  font-size: 1.4em;
  font-weight: 500;
}

.menu-offcanvas-content {
  padding-bottom: 0 !important;
}

.container-menu-mobile {
  overflow-y: scroll;
  display: flex;
  height: fill-available;
  height: -o-fill-available;
  height: -webkit-fill-available;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
}

.user-menu-mobile {
  border: none;
}

.user-menu-mobile button.accordion-button:not(.collapsed) {
  background-color: transparent;
  color: inherit;
}

.user-menu-mobile button.accordion-button:not(.collapsed)::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.user-menu-mobile button.accordion-button:focus {
  box-shadow: none;
  border: none;
}

button.accordion-button.collapsed {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.offcanvas div.user-menu-mobile-title {
  display: flex;
  flex-direction: column;
}

.offcanvas div.user-menu-mobile-username {
  font-size: 1.3em;
  font-weight: 800;
  text-transform: capitalize;
}

.offcanvas div.user-menu-mobile-email {
  font-size: 1.1em;
  color: #aaa;
  text-transform: lowercase;
}

ul.user-menu-mobile-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

ul.user-menu-mobile-links li {
  font-size: 1.1em;
  padding: 0.5em 0;
  font-weight: 500;
}

ul.user-menu-mobile-links li:last-child {
  text-align: right;
  color: #aaa;
}

ul.user-menu-mobile-links li:last-child button {
  opacity: 0.5;
}

ul.user-menu-mobile-links li:last-child button img {
  width: 20px;
  height: 22px;
}

ul.user-menu-mobile-links li a {
  text-decoration: none;
  color: #2b363b;
}

.menu li:hover {
  background-color: #e5e5e5;
}

.navbar-expand-md .navbar-nav,
.navbar-light .navbar-toggler {
  border: none;
}

.navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
}

.navbar-toggler:focus {
  box-shadow: none;
}

.nav-link:hover {
  /* background-color: #f1f1f1; */
}

#offcanvasNavbar {
  width: 101vw;
}

table {
  font-size: 0.9em;
}

/* ALERTS Y BUTTONS */

.alert {
  border-radius: 0.5em;
  padding: 0.41em 0.82em;
  margin: 0.5rem auto;
}

.alert-outline-primary {
  background-color: transparent;
  border-color: #db0b27;
  color: #db0b27;
  text-align: center;
}
.alert-outline-blue {
  background-color: transparent;
  border-color: #3ea7ee;
  color: #3ea7ee;
  text-align: center;
}
.alert-success {
  background-color: #2ecc71;
  border-color: #2ecc71;
  color: #fff;
  text-align: center;
}
.alert-outline-success {
  background-color: transparent;
  border-color: #2ecc71;
  color: #2ecc71;
  text-align: center;
}

.alert-warning {
  background-color: #fca534;
  border-color: #fca534;
  color: #fff;
  text-align: center;
}
.alert-diesel {
  background-color: #000000;
  border-color: #000000;
  color: #fff;
  text-align: center;
}
.alert-outline-warning {
  background-color: transparent;
  border-color: #fca534;
  color: #fca534;
  text-align: center;
}

.alert-default {
  background-color: #1d253c;
  border-color: #1d253c;
  color: #fff;
  text-align: center;
}

.btn-primary {
  background-color: #db0b27;
  border-color: #db0b27;
  color: #fff;
  font-weight: 600;
}

.btn-outline-primary {
  border-color: #db0b27;
  color: #db0b27;
  font-weight: 600;
}

.btn-outline-primary:disabled,
.btn-outline-primary.disabled {
  color: #fff;
  opacity: 0.5;
  background-color: #c4c4c4;
  border-color: #c4c4c4;
}

.btn:first-child:active,
.btn-primary:active,
.btn-primary:focus,
.btn-primary:hover {
  background-color: #c61517;
  border-color: #c61517;
}

.btn-check:checked + .btn,
:not(.btn-check) + .btn:active,
.btn-primary:active,
.btn-outline-primary:active,
.btn-outline-primary:focus,
.btn-outline-primary:hover {
  background-color: #db0b27;
  border-color: #db0b27;
}

.btn-outline-primary:focus,
.btn-primary:focus,
.btn-primary:active:focus {
  box-shadow: 0 0 0 0.25rem #ececec;
  color: #fff;
}

.btn-light {
  background-color: transparent;
  border: none;
  color: #db0b27;
  font-weight: 600;
}

.btn-light:active,
.btn-light:focus,
.btn-light:hover {
  background-color: transparent;
  border: none;
  color: #c61517;
}

.btn-secondary {
  background-color: #fff;
  border: none;
  color: #a5a5a5;
}

.btn-secondary:focus,
.btn-secondary:active,
.btn-secondary:hover,
.show > .btn-secondary.dropdown-toggle,
.show > .btn-secondary.dropdown-toggle:focus {
  background-color: #fff !important;
  box-shadow: none;
  color: #db0b27 !important;
}

.btn-secondary:active:focus {
  border: none;
  box-shadow: none;
}

.table-btn > img {
  margin: 0 0.3em;
  width: 23px;
  height: 23px;
}

.table-btn.block-icon-btn {
  margin-left: 0.5em;
}

.dropdown-toggle::after {
  border: none;
  content: "\\2838" !important;
  font-size: 3em;
}

.dropdown-item:active,
.dropdown-item:hover {
  background-color: #1d253c;
  color: #fff;
}

.dropdown-item:active > button > img,
.dropdown-item:hover > button > img {
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(3000%)
    contrast(100%);
}

.dropdown-item:hover
  > .form-check
  > .form-check-input[type="checkbox"]:checked
  ~ label {
  color: #fff !important;
}

/* .dropdown-item:focus,
.dropdown-item:hover {
  background-color: #fdf4f4;
} */

/* FORM STYLES */
.input-group-text {
  background-color: transparent;
  border-right: none;
}

.no-border-left {
  border-left: none;
}

.form-check-input[type="checkbox"] {
  border-radius: 0.2em;
  color: #fff;
  font-size: 1.3em;
  line-height: 1.3em;
  text-align: center;
}

.form-check-input:focus {
  border-color: #db0b27;
}

.form-check-input[type="checkbox"]:checked {
  background-color: #db0b27;
  border-color: #db0b27;
}

.form-check-input[type="checkbox"]:focus {
  border-color: #db0b27;
  box-shadow: none;
}

.form-check-input {
  border-color: rgba(0, 0, 0, 0.25);
}

.form-floating > label {
  font-weight: 700;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
}

.row .form-floating > label {
  padding-left: 1.5em;
}

.form-control:disabled {
  background-color: #fff;
  border: none;
  padding-left: 1.5em;
}
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control:focus ~ label,
.form-floating > .form-select ~ label {
  opacity: 1;
  color: #2b363b;
}

.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  background-color: transparent;
}

.form-floating > .form-control:focus ~ label {
  color: #db0b27;
}

.form-control,
.form-select {
  background-color: #ececec;
  border: none;
}

.form-control:focus {
  background-color: #fff;
  border: 1px solid #ced4da;
  /* box-shadow: 0 0 0.6em 0.15rem rgb(242, 109, 109, 55%); */
  box-shadow: none;
}

.form-control:disabled,
.form-control[readonly],
.form-control[readonly]:focus,
.form-select:disabled {
  background-color: #ececec;
  border: none;
  cursor: not-allowed;
}

.form-floating > .form-select:disabled ~ label,
.form-floating > .form-select:disabled {
  color: #6c757d;
}

.form-floating > .form-control[readonly]:focus ~ label {
  color: #212529;
}

/* MODAL STYLES */

.modal-content {
  border-radius: 0.7em;
}

.modal-header {
  border-bottom: none;
}

.modal-header .h4 {
  font-weight: 700;
  margin: 0 auto;
}

.modal-body h3.title-modal {
  text-align: center;
  font-weight: 700;
}

.flotas-modal-eliminar-pregunta {
  font-weight: 500;
  font-size: 0.9em;
}

/* FORM VALIDATION */
.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  border-color: #db0b27;
}

.was-validated .form-control:valid:focus,
.form-control.is-valid:focus,
.was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus {
  border-color: #db0b27;
  box-shadow: none;
}

.was-validated .form-select:valid:not([multiple]):not([size]),
.was-validated .form-select:valid:not([multiple])[size="1"],
.form-select.is-valid:not([multiple]):not([size]),
.form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-select:valid,
.form-select.is-valid {
  border-color: #db0b27;
}
/* .was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  position: absolute;
  margin-top: 7vh;
} */

.page-link,
ul.pagination .page-link {
  border: none;
  color: #db0b27;
}

.page-item.active .page-link {
  background-color: #db0b27;
  border-color: #db0b27;
  border-radius: 0.4em;
  color: #fff;
}

ul.pagination .page-link {
  cursor: pointer;
}

.page-item:hover {
  background-color: #e9ecef;
}

.page-link,
.page-link:hover {
  background: transparent;
}

ul.pagination .page-link.disabled {
  color: #c4c4c4;
  cursor: not-allowed;
  background-color: transparent;
  pointer-events: auto;
}

.pagination-showing-text {
  font-size: 0.9em;
  color: #777;
}

.pagination-select-results {
  display: flex;
  align-items: center;
  font-weight: 900;
}

.pagination-select-results > select.form-select.form-select-sm {
  width: -moz-fit-content;
  width: fit-content;
  background-color: #fff;
  border: 1px solid #1d253c;
  border-radius: 0.5em;
  margin: 0 0.6em;
}

.pagination-select-results > select.form-select:focus {
  box-shadow: none;
}

.order-table-icons svg {
  cursor: pointer;
}

.export-button {
  margin: 0 0.1em;
}

table {
  --bs-table-bg: transparent !important;
}

tbody > tr:hover {
  background-color: #f1f1f1;
  cursor: pointer;
}

.user-exit-img {
  width: 20px;
  height: 22px;
}

.header-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.header-help {
  margin-right: 1em;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.header-help-text {
  font-size: 1.1em;
}

.header-help-link {
  text-decoration: none;
  color: #2b363b;
}

.header-help-phone {
  font-size: 1.2em;
  font-weight: 700;
}

.header-help-icon {
  width: 1.6em;
  margin-left: 1em;
  margin-right: 0;
}

iframe#webpack-dev-server-client-overlay {
  display: none !important;
}

/* BREAKPOINT TABLETS*/
@media (min-width: 768px) {
  .page-header {
    margin-left: -6vw !important;
    /* padding-left: 3vw; */
    padding-right: 3vw;
  }
}

/* BREAKPOINT TABLETS*/
@media (min-width: 912px) {
  .page-header {
    margin-left: -13vw !important;
  }

  .container {
    max-width: 100% !important;
  }
}

/* BREAKPOINT ESCRITORIO */
@media (min-width: 992px) {
  /* General Styles */
  #root {
    display: flex;
  }

  .section-header {
    border-radius: none;
    box-shadow: none;
  }

  .page-header {
    align-items: flex-end !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    display: flex !important;
    margin-left: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    padding-right: 0 !important;
    position: inherit;
    width: inherit !important;
    z-index: 19;
  }

  .content-page {
    padding-top: 0.483em;
    margin-left: 19em;
  }

  .container {
    max-width: 1440px !important;
  }

  /* Header Styles */

  header {
    text-align: right;
    padding: 1em 3em 2em 0;
  }

  header .row {
    display: flow-root;
  }

  header .username {
    margin: 0 0.96em;
    font-weight: 800;
    vertical-align: middle;
    font-size: 1em;
    text-transform: capitalize;
  }

  .header-help-icon {
    margin-right: 0.5em;
    margin-left: 0;
    width: 1.4em;
  }

  .header-user-menu {
    text-align: right;
  }

  button.user-exit.btn.btn-light {
    display: contents;
  }

  .user-options button {
    display: inline-flex;
    align-items: center;
    color: #2b363b;
    border: 1px solid #2b363b2d;
    border-radius: 8px;
    padding: 0 1em 0 0em;
    width: 21.1em;
    max-width: 21.1em;
    justify-content: space-between;
    max-height: 4.6em;
    padding-top: 0.8em;
    padding-bottom: 0.8em;
  }

  .dropdown-menu.dropdown-menu-lg-end.header-user-menu.show {
    margin-top: -0.1em;
    /* margin-right: 0.7em; */
    text-align: left;
    width: 21.15em;
  }

  a.logout-item.dropdown-item {
    text-align: right;
  }

  .user-options button:hover,
  .user-options button:active,
  .user-options button:hover:active,
  .user-options.show > .btn-secondary.dropdown-toggle,
  .user-options > .btn-secondary:focus {
    color: #2b363b !important;
    border: 1px solid #2b363b2d !important;
  }

  .hr-no-heigth {
    height: 0 !important;
  }

  .user-options.show > .btn-secondary.dropdown-toggle {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .header-user-menu.dropdown-menu.show.dropdown-menu-lg-end {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .user-options .dropdown-toggle::after {
    color: #2b363b;
    /* content: "\\1F893" !important; */
    content: "" !important;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) !important;
    background-size: 1em;
    background-repeat: no-repeat;
    background-position: center;
    width: 1.2em;
    height: 1.2em;
    max-width: 16px;
    max-height: 14px;
    /* margin-left: 0.5em; */
    font-size: 0.8em;
    animation: rotate-up 0.3s ease-in-out;
    transform: scaleY(1);
  }

  .user-options .dropdown-toggle.show::after {
    transform: scaleY(-1);
    animation: rotate-down 0.3s ease-in-out;
  }

  @keyframes rotate-down {
    0% {
      transform: scaleY(1);
    }
    100% {
      transform: scaleY(-1);
    }
  }

  @keyframes rotate-up {
    0% {
      transform: scaleY(-1);
    }
    100% {
      transform: scaleY(1);
    }
  }

  .user-config,
  .user-exit {
    /* box-shadow: 0px 20px 50px rgba(191, 21, 108, 0.05);
    margin: 1vw 0.5vw; */
    box-shadow: none;
    display: contents;
  }

  .user-config:focus,
  .user-config:active:focus {
    box-shadow: none;
  }

  /* Nav Styles */

  .navbar {
    max-height: 100%;
    max-width: 19em;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding-top: min(10vh, 13vh);
  }

  .navbar::-webkit-scrollbar {
    display: none;
  }

  h5.navbar-logo-footer {
    font-weight: 800;
    text-align: left;
    margin-top: 0.5em;
    padding-left: 0.5em;
  }

  .me-auto a {
    border: none;
  }

  .nav-link {
    font-size: 1.2em;
    font-weight: 700;
    line-height: 1.7em;
  }

  .nav-link:active {
    color: #db0b27 !important;
  }

  .nav-link:active img {
    filter: contrast(86%) sepia(1) hue-rotate(300deg) saturate(1000%);
  }

  .navbar-brand {
    padding-left: 0.5em;
  }

  .navbar-brand img {
    width: 194px;
  }

  .navbar > .container {
    display: block;
  }

  .navbar > .container > .me-auto {
    text-align: left;
  }

  .navbar-expand-md .navbar-nav {
    display: block;
  }

  .navbar-expand .navbar-nav {
    flex-direction: column;
  }

  .page-link,
  ul.pagination .page-link {
    border: none;
    color: #db0b27;
  }

  .page-item.active .page-link {
    background-color: #db0b27;
    border-color: #db0b27;
    border-radius: 0.4em;
  }

  ul.pagination .page-link {
    cursor: pointer;
  }

  ul.pagination .page-link.disabled {
    color: #c4c4c4;
    cursor: not-allowed;
  }

  form .mt-5 {
    margin-top: 2em !important;
  }

  .page-header h1 {
    font-size: 1.45em;
    padding-left: 0;
  }

  .content-has-flotas {
    margin-top: inherit;
  }

  .flotas.content-has-flotas {
    margin-top: inherit;
  }

  .header-options {
    display: flex !important;
    justify-content: flex-end !important;
  }

  /* Barras de scroll */
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  ::-webkit-scrollbar-thumb {
    /* background: rgb(214, 214, 214); */
    background: #c61517;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
}

/* BREAKPOINT ESCRITORIO Grande */
@media (min-width: 1537px) {
  body {
    margin-left: 2em;
  }

  .navbar {
    max-width: 24em;
  }

  .content-page {
    margin-left: 24em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAQA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,2CAA2C;EAC3C,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;GAEG;;AAEH;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EAEb,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,yDAAqT;AACvT;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,oEAAkE;AACpE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;;AAErB;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;EAIE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;;;;;EAKE,iCAAiC;EACjC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE;kBACgB;AAClB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;;;GAGG;;AAEH,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;AACA;;;EAGE,UAAU;EACV,cAAc;AAChB;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,2DAA2D;EAC3D,gBAAgB;AAClB;;AAEA;;;;EAIE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;;AAEjB;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;;EAEE,yDAA4P;EAC5P,qBAAqB;AACvB;;AAEA;;;;EAIE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;;EAIE,iEAAoQ;EACpQ,gEAAgE;AAClE;;AAEA;;EAEE,qBAAqB;AACvB;AACA;;;;;;GAMG;;AAEH;;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;IAChC,2BAA2B;IAC3B,2BAA2B;IAC3B,wBAAwB;IACxB,yBAAyB;IACzB,yBAAyB;IACzB,4BAA4B;IAC5B,2BAA2B;IAC3B,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA,kBAAkB;;EAElB;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,2BAA2B;IAC3B,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,iBAAiB;IACjB,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;;;IAKE,yBAAyB;IACzB,sCAAsC;EACxC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,kCAAkC;IAClC,sBAAsB;IACtB,oEAAuE;IACvE,oBAAoB;IACpB,4BAA4B;IAC5B,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,uCAAuC;EACzC;;EAEA;IACE;MACE,oBAAoB;IACtB;IACA;MACE,qBAAqB;IACvB;EACF;;EAEA;IACE;MACE,qBAAqB;IACvB;IACA;MACE,oBAAoB;IACtB;EACF;;EAEA;;IAEE;wBACoB;IACpB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA,eAAe;;EAEf;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iEAAiE;EACnE;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,oCAAoC;EACtC;;EAEA,qBAAqB;EACrB;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,oCAAoC;IACpC,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["@import \"bootstrap/dist/css/bootstrap.css\";\n\n::-moz-selection {\n  /* Code for Firefox */\n  color: #fff;\n  background: #db0b27;\n}\n\n::selection {\n  color: #fff;\n  background: #db0b27;\n}\n\nbody {\n  color: #2b363b;\n  font-family: \"Red Hat Display\", \"Poppins\", sans-serif;\n}\n\n.Toastify__progress-bar-theme--light {\n  background: #db0b27 !important;\n}\n\n.Toastify__toast-container {\n  width: 350px !important;\n}\n\n.passwordIcon {\n  width: 24px;\n  height: 24px;\n}\n\n.red-text {\n  color: #db0b27;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.menu-logo-mobile {\n  width: 160px;\n}\n\n.menu-user-icon {\n  width: 32px;\n  margin-left: 8px;\n}\n\n.menu-facturas-icon {\n  width: 41px;\n}\n\n.menu-repostajes-icon {\n  width: 53px;\n}\n\n.menu-promotion-icon {\n  width: 39px;\n  margin-left: 1px;\n}\n\n.menu-stats-icon {\n  width: 44px;\n}\n\n.menu-flotas-icon {\n  width: 45px;\n}\n\n/* General Styles */\n.page-header {\n  background-color: #fff;\n  border-radius: 0 0 20px 20px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  margin-left: -6vw !important;\n  padding-top: 6em;\n  padding-bottom: 1em;\n  position: fixed;\n  width: 100vw;\n  z-index: 19;\n}\n\n.username {\n  display: block;\n  text-align: left;\n  font-weight: 800;\n}\n\n.user-email {\n  display: block;\n  text-align: left;\n  font-size: 0.9em;\n  color: #aaa;\n  text-transform: lowercase;\n}\n\n.has-flotas {\n  padding-top: 10em;\n}\n\n.no-shadow {\n  box-shadow: none !important;\n}\n\n/* .flotas.has-flotas {\n  padding-top: 26vh;\n} */\n\n.page-header h1 {\n  font-size: 1.5em;\n  font-weight: 700;\n}\n\nh2 {\n  font-weight: 700;\n  font-size: 1.3em;\n}\n\n.content-page {\n  padding-top: 6vh;\n}\n\n.content-section {\n  margin-top: 24vh;\n}\n\n.content-has-flotas {\n  margin-top: 18em;\n}\n\n.flotas.content-has-flotas {\n  margin-top: 23em;\n}\n\n.section {\n  box-shadow: 0px 20px 50px rgba(191, 21, 108, 0.05);\n  border-radius: 20px;\n}\n\n.section-header-text {\n  height: 1.5em;\n  line-height: 1.5em;\n}\n\n.section-header-btn {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.icon-bg {\n  padding: 1.09em 1.09em;\n  background-color: #ececec;\n  border-radius: 0.5em;\n}\n\na.no-decoration {\n  color: inherit;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n/* Nav Styles */\n.navbar {\n  background-color: #fff;\n  display: block;\n  padding-top: 4.1em;\n  position: fixed;\n  width: 100vw;\n  z-index: 20;\n}\n\n.me-auto a {\n  border: none;\n  border-bottom: 1px solid #c4c4c4;\n}\n\n.menu span,\n.offcanvas span {\n  color: #2b363b;\n  font-size: 1.4em;\n  font-weight: 500;\n}\n\n.menu-offcanvas-content {\n  padding-bottom: 0 !important;\n}\n\n.container-menu-mobile {\n  overflow-y: scroll;\n  display: flex;\n  height: -moz-available;\n  height: fill-available;\n  height: -o-fill-available;\n  height: -webkit-fill-available;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: space-between;\n}\n\n.user-menu-mobile {\n  border: none;\n}\n\n.user-menu-mobile button.accordion-button:not(.collapsed) {\n  background-color: transparent;\n  color: inherit;\n}\n\n.user-menu-mobile button.accordion-button:not(.collapsed)::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e\");\n}\n\n.user-menu-mobile button.accordion-button:focus {\n  box-shadow: none;\n  border: none;\n}\n\nbutton.accordion-button.collapsed {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.offcanvas div.user-menu-mobile-title {\n  display: flex;\n  flex-direction: column;\n}\n\n.offcanvas div.user-menu-mobile-username {\n  font-size: 1.3em;\n  font-weight: 800;\n  text-transform: capitalize;\n}\n\n.offcanvas div.user-menu-mobile-email {\n  font-size: 1.1em;\n  color: #aaa;\n  text-transform: lowercase;\n}\n\nul.user-menu-mobile-links {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\nul.user-menu-mobile-links li {\n  font-size: 1.1em;\n  padding: 0.5em 0;\n  font-weight: 500;\n}\n\nul.user-menu-mobile-links li:last-child {\n  text-align: right;\n  color: #aaa;\n}\n\nul.user-menu-mobile-links li:last-child button {\n  opacity: 0.5;\n}\n\nul.user-menu-mobile-links li:last-child button img {\n  width: 20px;\n  height: 22px;\n}\n\nul.user-menu-mobile-links li a {\n  text-decoration: none;\n  color: #2b363b;\n}\n\n.menu li:hover {\n  background-color: #e5e5e5;\n}\n\n.navbar-expand-md .navbar-nav,\n.navbar-light .navbar-toggler {\n  border: none;\n}\n\n.navbar-toggler-icon {\n  background-image: url(\"../assets/images/menu-icon.svg\") !important;\n}\n\n.navbar-toggler:focus {\n  box-shadow: none;\n}\n\n.nav-link:hover {\n  /* background-color: #f1f1f1; */\n}\n\n#offcanvasNavbar {\n  width: 101vw;\n}\n\ntable {\n  font-size: 0.9em;\n}\n\n/* ALERTS Y BUTTONS */\n\n.alert {\n  border-radius: 0.5em;\n  padding: 0.41em 0.82em;\n  margin: 0.5rem auto;\n}\n\n.alert-outline-primary {\n  background-color: transparent;\n  border-color: #db0b27;\n  color: #db0b27;\n  text-align: center;\n}\n.alert-outline-blue {\n  background-color: transparent;\n  border-color: #3ea7ee;\n  color: #3ea7ee;\n  text-align: center;\n}\n.alert-success {\n  background-color: #2ecc71;\n  border-color: #2ecc71;\n  color: #fff;\n  text-align: center;\n}\n.alert-outline-success {\n  background-color: transparent;\n  border-color: #2ecc71;\n  color: #2ecc71;\n  text-align: center;\n}\n\n.alert-warning {\n  background-color: #fca534;\n  border-color: #fca534;\n  color: #fff;\n  text-align: center;\n}\n.alert-diesel {\n  background-color: #000000;\n  border-color: #000000;\n  color: #fff;\n  text-align: center;\n}\n.alert-outline-warning {\n  background-color: transparent;\n  border-color: #fca534;\n  color: #fca534;\n  text-align: center;\n}\n\n.alert-default {\n  background-color: #1d253c;\n  border-color: #1d253c;\n  color: #fff;\n  text-align: center;\n}\n\n.btn-primary {\n  background-color: #db0b27;\n  border-color: #db0b27;\n  color: #fff;\n  font-weight: 600;\n}\n\n.btn-outline-primary {\n  border-color: #db0b27;\n  color: #db0b27;\n  font-weight: 600;\n}\n\n.btn-outline-primary:disabled,\n.btn-outline-primary.disabled {\n  color: #fff;\n  opacity: 0.5;\n  background-color: #c4c4c4;\n  border-color: #c4c4c4;\n}\n\n.btn:first-child:active,\n.btn-primary:active,\n.btn-primary:focus,\n.btn-primary:hover {\n  background-color: #c61517;\n  border-color: #c61517;\n}\n\n.btn-check:checked + .btn,\n:not(.btn-check) + .btn:active,\n.btn-primary:active,\n.btn-outline-primary:active,\n.btn-outline-primary:focus,\n.btn-outline-primary:hover {\n  background-color: #db0b27;\n  border-color: #db0b27;\n}\n\n.btn-outline-primary:focus,\n.btn-primary:focus,\n.btn-primary:active:focus {\n  box-shadow: 0 0 0 0.25rem #ececec;\n  color: #fff;\n}\n\n.btn-light {\n  background-color: transparent;\n  border: none;\n  color: #db0b27;\n  font-weight: 600;\n}\n\n.btn-light:active,\n.btn-light:focus,\n.btn-light:hover {\n  background-color: transparent;\n  border: none;\n  color: #c61517;\n}\n\n.btn-secondary {\n  background-color: #fff;\n  border: none;\n  color: #a5a5a5;\n}\n\n.btn-secondary:focus,\n.btn-secondary:active,\n.btn-secondary:hover,\n.show > .btn-secondary.dropdown-toggle,\n.show > .btn-secondary.dropdown-toggle:focus {\n  background-color: #fff !important;\n  box-shadow: none;\n  color: #db0b27 !important;\n}\n\n.btn-secondary:active:focus {\n  border: none;\n  box-shadow: none;\n}\n\n.table-btn > img {\n  margin: 0 0.3em;\n  width: 23px;\n  height: 23px;\n}\n\n.table-btn.block-icon-btn {\n  margin-left: 0.5em;\n}\n\n.dropdown-toggle::after {\n  border: none;\n  content: \"\\2838\" !important;\n  font-size: 3em;\n}\n\n.dropdown-item:active,\n.dropdown-item:hover {\n  background-color: #1d253c;\n  color: #fff;\n}\n\n.dropdown-item:active > button > img,\n.dropdown-item:hover > button > img {\n  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(3000%)\n    contrast(100%);\n}\n\n.dropdown-item:hover\n  > .form-check\n  > .form-check-input[type=\"checkbox\"]:checked\n  ~ label {\n  color: #fff !important;\n}\n\n/* .dropdown-item:focus,\n.dropdown-item:hover {\n  background-color: #fdf4f4;\n} */\n\n/* FORM STYLES */\n.input-group-text {\n  background-color: transparent;\n  border-right: none;\n}\n\n.no-border-left {\n  border-left: none;\n}\n\n.form-check-input[type=\"checkbox\"] {\n  border-radius: 0.2em;\n  color: #fff;\n  font-size: 1.3em;\n  line-height: 1.3em;\n  text-align: center;\n}\n\n.form-check-input:focus {\n  border-color: #db0b27;\n}\n\n.form-check-input[type=\"checkbox\"]:checked {\n  background-color: #db0b27;\n  border-color: #db0b27;\n}\n\n.form-check-input[type=\"checkbox\"]:focus {\n  border-color: #db0b27;\n  box-shadow: none;\n}\n\n.form-check-input {\n  border-color: rgba(0, 0, 0, 0.25);\n}\n\n.form-floating > label {\n  font-weight: 700;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 100%;\n}\n\n.row .form-floating > label {\n  padding-left: 1.5em;\n}\n\n.form-control:disabled {\n  background-color: #fff;\n  border: none;\n  padding-left: 1.5em;\n}\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-select ~ label {\n  opacity: 1;\n  color: #2b363b;\n}\n\n.form-floating > .form-control:focus ~ label::after,\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after,\n.form-floating > .form-control-plaintext ~ label::after,\n.form-floating > .form-select ~ label::after {\n  background-color: transparent;\n}\n\n.form-floating > .form-control:focus ~ label {\n  color: #db0b27;\n}\n\n.form-control,\n.form-select {\n  background-color: #ececec;\n  border: none;\n}\n\n.form-control:focus {\n  background-color: #fff;\n  border: 1px solid #ced4da;\n  /* box-shadow: 0 0 0.6em 0.15rem rgb(242, 109, 109, 55%); */\n  box-shadow: none;\n}\n\n.form-control:disabled,\n.form-control[readonly],\n.form-control[readonly]:focus,\n.form-select:disabled {\n  background-color: #ececec;\n  border: none;\n  cursor: not-allowed;\n}\n\n.form-floating > .form-select:disabled ~ label,\n.form-floating > .form-select:disabled {\n  color: #6c757d;\n}\n\n.form-floating > .form-control[readonly]:focus ~ label {\n  color: #212529;\n}\n\n/* MODAL STYLES */\n\n.modal-content {\n  border-radius: 0.7em;\n}\n\n.modal-header {\n  border-bottom: none;\n}\n\n.modal-header .h4 {\n  font-weight: 700;\n  margin: 0 auto;\n}\n\n.modal-body h3.title-modal {\n  text-align: center;\n  font-weight: 700;\n}\n\n.flotas-modal-eliminar-pregunta {\n  font-weight: 500;\n  font-size: 0.9em;\n}\n\n/* FORM VALIDATION */\n.was-validated .form-control:valid,\n.form-control.is-valid {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23db0b27' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  border-color: #db0b27;\n}\n\n.was-validated .form-control:valid:focus,\n.form-control.is-valid:focus,\n.was-validated .form-control:invalid:focus,\n.form-control.is-invalid:focus {\n  border-color: #db0b27;\n  box-shadow: none;\n}\n\n.was-validated .form-select:valid:not([multiple]):not([size]),\n.was-validated .form-select:valid:not([multiple])[size=\"1\"],\n.form-select.is-valid:not([multiple]):not([size]),\n.form-select.is-valid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23db0b27' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.was-validated .form-select:valid,\n.form-select.is-valid {\n  border-color: #db0b27;\n}\n/* .was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  position: absolute;\n  margin-top: 7vh;\n} */\n\n.page-link,\nul.pagination .page-link {\n  border: none;\n  color: #db0b27;\n}\n\n.page-item.active .page-link {\n  background-color: #db0b27;\n  border-color: #db0b27;\n  border-radius: 0.4em;\n  color: #fff;\n}\n\nul.pagination .page-link {\n  cursor: pointer;\n}\n\n.page-item:hover {\n  background-color: #e9ecef;\n}\n\n.page-link,\n.page-link:hover {\n  background: transparent;\n}\n\nul.pagination .page-link.disabled {\n  color: #c4c4c4;\n  cursor: not-allowed;\n  background-color: transparent;\n  pointer-events: auto;\n}\n\n.pagination-showing-text {\n  font-size: 0.9em;\n  color: #777;\n}\n\n.pagination-select-results {\n  display: flex;\n  align-items: center;\n  font-weight: 900;\n}\n\n.pagination-select-results > select.form-select.form-select-sm {\n  width: fit-content;\n  background-color: #fff;\n  border: 1px solid #1d253c;\n  border-radius: 0.5em;\n  margin: 0 0.6em;\n}\n\n.pagination-select-results > select.form-select:focus {\n  box-shadow: none;\n}\n\n.order-table-icons svg {\n  cursor: pointer;\n}\n\n.export-button {\n  margin: 0 0.1em;\n}\n\ntable {\n  --bs-table-bg: transparent !important;\n}\n\ntbody > tr:hover {\n  background-color: #f1f1f1;\n  cursor: pointer;\n}\n\n.user-exit-img {\n  width: 20px;\n  height: 22px;\n}\n\n.header-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.header-help {\n  margin-right: 1em;\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n}\n\n.header-help-text {\n  font-size: 1.1em;\n}\n\n.header-help-link {\n  text-decoration: none;\n  color: #2b363b;\n}\n\n.header-help-phone {\n  font-size: 1.2em;\n  font-weight: 700;\n}\n\n.header-help-icon {\n  width: 1.6em;\n  margin-left: 1em;\n  margin-right: 0;\n}\n\niframe#webpack-dev-server-client-overlay {\n  display: none !important;\n}\n\n/* BREAKPOINT TABLETS*/\n@media (min-width: 768px) {\n  .page-header {\n    margin-left: -6vw !important;\n    /* padding-left: 3vw; */\n    padding-right: 3vw;\n  }\n}\n\n/* BREAKPOINT TABLETS*/\n@media (min-width: 912px) {\n  .page-header {\n    margin-left: -13vw !important;\n  }\n\n  .container {\n    max-width: 100% !important;\n  }\n}\n\n/* BREAKPOINT ESCRITORIO */\n@media (min-width: 992px) {\n  /* General Styles */\n  #root {\n    display: flex;\n  }\n\n  .section-header {\n    border-radius: none;\n    box-shadow: none;\n  }\n\n  .page-header {\n    align-items: flex-end !important;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n    display: flex !important;\n    margin-left: 0 !important;\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    padding-right: 0 !important;\n    position: inherit;\n    width: inherit !important;\n    z-index: 19;\n  }\n\n  .content-page {\n    padding-top: 0.483em;\n    margin-left: 19em;\n  }\n\n  .container {\n    max-width: 1440px !important;\n  }\n\n  /* Header Styles */\n\n  header {\n    text-align: right;\n    padding: 1em 3em 2em 0;\n  }\n\n  header .row {\n    display: flow-root;\n  }\n\n  header .username {\n    margin: 0 0.96em;\n    font-weight: 800;\n    vertical-align: middle;\n    font-size: 1em;\n    text-transform: capitalize;\n  }\n\n  .header-help-icon {\n    margin-right: 0.5em;\n    margin-left: 0;\n    width: 1.4em;\n  }\n\n  .header-user-menu {\n    text-align: right;\n  }\n\n  button.user-exit.btn.btn-light {\n    display: contents;\n  }\n\n  .user-options button {\n    display: inline-flex;\n    align-items: center;\n    color: #2b363b;\n    border: 1px solid #2b363b2d;\n    border-radius: 8px;\n    padding: 0 1em 0 0em;\n    width: 21.1em;\n    max-width: 21.1em;\n    justify-content: space-between;\n    max-height: 4.6em;\n    padding-top: 0.8em;\n    padding-bottom: 0.8em;\n  }\n\n  .dropdown-menu.dropdown-menu-lg-end.header-user-menu.show {\n    margin-top: -0.1em;\n    /* margin-right: 0.7em; */\n    text-align: left;\n    width: 21.15em;\n  }\n\n  a.logout-item.dropdown-item {\n    text-align: right;\n  }\n\n  .user-options button:hover,\n  .user-options button:active,\n  .user-options button:hover:active,\n  .user-options.show > .btn-secondary.dropdown-toggle,\n  .user-options > .btn-secondary:focus {\n    color: #2b363b !important;\n    border: 1px solid #2b363b2d !important;\n  }\n\n  .hr-no-heigth {\n    height: 0 !important;\n  }\n\n  .user-options.show > .btn-secondary.dropdown-toggle {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .header-user-menu.dropdown-menu.show.dropdown-menu-lg-end {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n\n  .user-options .dropdown-toggle::after {\n    color: #2b363b;\n    /* content: \"\\1F893\" !important; */\n    content: \"\" !important;\n    background-image: url(\"../assets/images/user-menu-icon.svg\") !important;\n    background-size: 1em;\n    background-repeat: no-repeat;\n    background-position: center;\n    width: 1.2em;\n    height: 1.2em;\n    max-width: 16px;\n    max-height: 14px;\n    /* margin-left: 0.5em; */\n    font-size: 0.8em;\n    animation: rotate-up 0.3s ease-in-out;\n    transform: scaleY(1);\n  }\n\n  .user-options .dropdown-toggle.show::after {\n    transform: scaleY(-1);\n    animation: rotate-down 0.3s ease-in-out;\n  }\n\n  @keyframes rotate-down {\n    0% {\n      transform: scaleY(1);\n    }\n    100% {\n      transform: scaleY(-1);\n    }\n  }\n\n  @keyframes rotate-up {\n    0% {\n      transform: scaleY(-1);\n    }\n    100% {\n      transform: scaleY(1);\n    }\n  }\n\n  .user-config,\n  .user-exit {\n    /* box-shadow: 0px 20px 50px rgba(191, 21, 108, 0.05);\n    margin: 1vw 0.5vw; */\n    box-shadow: none;\n    display: contents;\n  }\n\n  .user-config:focus,\n  .user-config:active:focus {\n    box-shadow: none;\n  }\n\n  /* Nav Styles */\n\n  .navbar {\n    max-height: 100%;\n    max-width: 19em;\n    overflow-y: auto;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    padding-top: min(10vh, 13vh);\n  }\n\n  .navbar::-webkit-scrollbar {\n    display: none;\n  }\n\n  h5.navbar-logo-footer {\n    font-weight: 800;\n    text-align: left;\n    margin-top: 0.5em;\n    padding-left: 0.5em;\n  }\n\n  .me-auto a {\n    border: none;\n  }\n\n  .nav-link {\n    font-size: 1.2em;\n    font-weight: 700;\n    line-height: 1.7em;\n  }\n\n  .nav-link:active {\n    color: #db0b27 !important;\n  }\n\n  .nav-link:active img {\n    filter: contrast(86%) sepia(1) hue-rotate(300deg) saturate(1000%);\n  }\n\n  .navbar-brand {\n    padding-left: 0.5em;\n  }\n\n  .navbar-brand img {\n    width: 194px;\n  }\n\n  .navbar > .container {\n    display: block;\n  }\n\n  .navbar > .container > .me-auto {\n    text-align: left;\n  }\n\n  .navbar-expand-md .navbar-nav {\n    display: block;\n  }\n\n  .navbar-expand .navbar-nav {\n    flex-direction: column;\n  }\n\n  .page-link,\n  ul.pagination .page-link {\n    border: none;\n    color: #db0b27;\n  }\n\n  .page-item.active .page-link {\n    background-color: #db0b27;\n    border-color: #db0b27;\n    border-radius: 0.4em;\n  }\n\n  ul.pagination .page-link {\n    cursor: pointer;\n  }\n\n  ul.pagination .page-link.disabled {\n    color: #c4c4c4;\n    cursor: not-allowed;\n  }\n\n  form .mt-5 {\n    margin-top: 2em !important;\n  }\n\n  .page-header h1 {\n    font-size: 1.45em;\n    padding-left: 0;\n  }\n\n  .content-has-flotas {\n    margin-top: inherit;\n  }\n\n  .flotas.content-has-flotas {\n    margin-top: inherit;\n  }\n\n  .header-options {\n    display: flex !important;\n    justify-content: flex-end !important;\n  }\n\n  /* Barras de scroll */\n  ::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    /* background: rgb(214, 214, 214); */\n    background: #c61517;\n    border-radius: 10px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 10px;\n  }\n}\n\n/* BREAKPOINT ESCRITORIO Grande */\n@media (min-width: 1537px) {\n  body {\n    margin-left: 2em;\n  }\n\n  .navbar {\n    max-width: 24em;\n  }\n\n  .content-page {\n    margin-left: 24em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
